import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20dark%20crimson%20red%20gradient%20background%20with%20soft%20glowing%20bokeh%20lights%20and%20drifting%20cherry%20blossom%20petals%2C%20elegant%20premium%20streaming%20platform%20hero%20art%2C%20moody%20atmosphere%2C%20rich%20deep%20tones%2C%20high%20detail&width=1920&height=1080&seq=cherry-hero-2026-a1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
        <div className="absolute inset-0 bg-primary-950/20"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 py-28 md:py-32">
        <div className="max-w-5xl mx-auto text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-50 text-xs md:text-sm backdrop-blur-sm">
            <i className="ri-map-pin-2-line"></i>
            官方入口 · 最新地址 · 防走失指引
          </span>

          <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
            樱桃视频最新地址
            <span className="block mt-2 text-primary-200">官网入口与 App 下载指南</span>
          </h1>

          <p className="mt-6 mx-auto max-w-2xl text-sm md:text-base text-background-100/90 leading-relaxed">
            本页为樱桃视频用户提供最新地址与官网入口指引。当你遇到网址打不开或域名失效时，
            可回到本页获取防走失方案，并找到 App 下载方式。建议收藏本页，方便随时访问。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#address"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-links-line"></i>
              查看最新可用地址
            </a>
            <a
              href="#download"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-download-line"></i>
              前往 App 下载
            </a>
          </div>

          <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
            {heroStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur-sm px-4 py-4 text-center"
              >
                <p className="font-heading text-lg md:text-xl font-semibold text-background-50">{stat.value}</p>
                <p className="mt-1 text-xs md:text-sm text-background-100/80">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}